// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var Sort_Enum;
(function (Sort_Enum) {
    Sort_Enum["DESC"] = "DESC";
    Sort_Enum["ASC"] = "ASC";
})(Sort_Enum || (Sort_Enum = {}));
export var Sort_Enum_index;
(function (Sort_Enum_index) {
    Sort_Enum_index[Sort_Enum_index["DESC"] = 0] = "DESC";
    Sort_Enum_index[Sort_Enum_index["ASC"] = 1] = "ASC";
})(Sort_Enum_index || (Sort_Enum_index = {}));
export const SMSDraftService = {
    /**
     * Upsert creates or updates a draft for a given combination of org_id, thread_id, and user_id.
     * Returns the draft_id and the draft itself.
     */
    Upsert(fn, req) {
        return fn(`/sms/draft/v1/draft`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Get retrieves a draft for a given combination of org_id, thread_id, and user_id.
     * Returns the draft_id and the draft itself.
     */
    Get(fn, req) {
        try {
            fm.validateUrlParam(req["threadId"], "threadId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/sms/draft/v1/draft/${req["threadId"]}?${fm.renderURLSearchParams(req, ["threadId"])}`, { method: "GET" });
    },
    /**
     * Delete deletes a draft for a given combination of org_id, thread_id, and user_id.
     */
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["threadId"], "threadId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/sms/draft/v1/draft/${req["threadId"]}?${fm.renderURLSearchParams(req, ["threadId"])}`, { method: "DELETE" });
    },
    /**
     * ListDrafts retrieves all drafts for a given user_id and org_id.
     * It returns a list of thread_ids and their drafts.
     */
    ListDrafts(fn, req) {
        return fn(`/sms/draft/v1/drafts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListDraftsCount retrieves the count of drafts for a given user_id and org_id. ( group_ids optional )
     * It returns the count of drafts.
     */
    ListDraftsCount(fn, req) {
        return fn(`/sms/draft/v1/drafts:count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GenerateSmartDraft generates a smart draft based on the provided messages.
     * It returns a suggested message generated by gemini that can be used as a draft.
     */
    GenerateSmartDraft(fn, req) {
        return fn(`/sms/draft/v1/drafts:generatesmart`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
